import { render, staticRenderFns } from "./addDirect.vue?vue&type=template&id=172af81a&scoped=true&"
import script from "./addDirect.vue?vue&type=script&lang=js&"
export * from "./addDirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172af81a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2024/xushanB/sdGGAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('172af81a')) {
      api.createRecord('172af81a', component.options)
    } else {
      api.reload('172af81a', component.options)
    }
    module.hot.accept("./addDirect.vue?vue&type=template&id=172af81a&scoped=true&", function () {
      api.rerender('172af81a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/member/memberSpecialDirect/addDirect.vue"
export default component.exports